import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  makeStyles,
  Theme,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import {
  getProbeSummaryThunk,
  getProbes,
  isLoading,
} from "features/probe/probeSlice";
import { hubData } from "features/hub/hubSlice";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Loading from "../../components/Loading";
import ProbeOverView from "../../components/ProbeOverView";
import useTimeout from "hooks/useTimeout";

/**
 * Home style
 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      paddingTop: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
  })
);

const Home = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  /**
   * Selectors
   */
  const probeData = useSelector(getProbes);
  const hub = useSelector(hubData);
  const loading = useSelector(isLoading);

  /**
   * States
   */
  const [probes, setProbes] = useState<Array<common.Probe>>();

  /**
   * Life cycles
   */
  // Fetch the probe data
  useEffect(() => {
    if (hub?.probeIds) {
      dispatch(getProbeSummaryThunk(hub.probeIds));
    }
  }, [hub?.id]);

  // Set state probe data when selector changes
  useEffect(() => {
    setProbes(probeData);
  }, [probeData]);

  const probeSummary = () => {
    if (loading) return <Loading />;

    if (probes) {
      const probeCards = probes?.map((probe: common.Probe) => (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <ProbeOverView probe={probe} />
        </Grid>
      ));

      // return <div className={classes.probeSummary}>{probeCards}</div>;
      return probeCards;
    }
  };

  return (
    <Grid container className={classes.container} spacing={3}>
      {probeSummary()}
    </Grid>
  );
};

export default Home;
